import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlTimer extends BaseControl {
    private _time: HTMLDivElement;
    private _duration: HTMLDivElement;

    constructor(pano: Pano) {
        super(pano, ControlPosition.LEFT);

        this.element.classList.add("timer");
        this.element.innerHTML = `
            <div class="timer-current">0:00</div>
            <div class="timer-separator">/</div>
            <div class="timer-duration">0:00</div>
        `;
        this._time = this.element.querySelector(".timer-current");
        this._duration = this.element.querySelector(".timer-duration");

        var updateDuration = () => {
            this._duration.textContent = this.secondsToTimestring(this._video.duration);
        }

        var updateTime = () => {
            this._time.textContent = this.secondsToTimestring(this._video.duration ? this._video.currentTime : NaN);
        }

        this._video.addEventListener("canplay", () => updateDuration());
        this._video.addEventListener("timeupdate", () => updateTime());

        this.pano.onChangeVideo.add(() => this.reset());
    }

    private reset(): void {
        this._time.textContent = this.secondsToTimestring(NaN);
        this._duration.textContent = this.secondsToTimestring(NaN);
    }

    private secondsToTimestring(seconds: number): string {
        if (isNaN(seconds))
            return "0:00";
        seconds = Math.round(seconds);
        var minutes = Math.floor(seconds / 60);
        var secondsLeft = seconds % 60;
        return minutes + ":" + ((secondsLeft < 10) ? "0" + secondsLeft : secondsLeft);
    }
}